var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgClose = function SvgClose(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M71.0714 64.0006L126.536 8.53606C128.488 6.58331 128.488 3.41731 126.536 1.46481C124.583 -0.487693 121.417 -0.487943 119.464 1.46481L63.9999 56.9293L8.53569 1.46481C6.58294 -0.487943 3.41694 -0.487943 1.46444 1.46481C-0.48806 3.41756 -0.48831 6.58356 1.46444 8.53606L56.9287 64.0003L1.46444 119.465C-0.48831 121.418 -0.48831 124.584 1.46444 126.536C2.44069 127.512 3.72044 128 5.00019 128C6.27994 128 7.55944 127.512 8.53594 126.536L63.9999 71.0718L119.464 126.536C120.44 127.512 121.72 128 123 128C124.28 128 125.559 127.512 126.536 126.536C128.488 124.583 128.488 121.417 126.536 119.465L71.0714 64.0006Z",
    fill: "black"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgClose, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/close.b57ca469.svg";
export { ForwardRef as ReactComponent };